import {Component, computed, input, OnDestroy} from '@angular/core';
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {Subscription} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {AlertComponent} from "../../../common/alert/alert.component";
import {AlertService} from "../../../common/alert/alert.service";
import {PropertyTypePipe} from "./property-type.pipe";
import {LicenseComponent} from "./license/license.component";
import {PinholeUser, PinholeUserService} from "../services/pinhole.user.service";
import {PinholeRoundService} from "../services/pinhole.round.service";
import {AddServerPropertyComponent} from "./add-server-property/add-server-property.component";

@Component({
    selector: 'search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.css'],
    providers: [AlertService],
    imports: [
        DatePipe,
        RouterLink,
        NgIf,
        NgForOf,
        AlertComponent,
        PropertyTypePipe,
        LicenseComponent,
        AddServerPropertyComponent,
    ]
})
export class SearchResultComponent implements OnDestroy {
    selectedTab = Tab.Installs
    private subscriptions: Subscription[] = [];
    readonly user = input<PinholeUser | null>(null)

    readonly hasUser = computed(() => {
        return this.user() !== null
    })

    readonly login = computed(() => {
        return this.user()?.login
    })

    readonly iid = computed(() => {
        return this.user()?.iid
    })

    readonly rounds = computed(() => {
        return this.user()?.rounds || []
    })

    readonly installs = computed(() => {
        return this.user()?.installs || []
    })

    readonly properties = computed(() => {
        return this.user()?.properties || []
    })

    constructor(private service: PinholeRoundService, private alertService: AlertService) {

    }

    selectTab(tab: Tab): void {
        this.selectedTab = tab;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    handleDeleteOrUndelete(event: MouseEvent, isDeleted: boolean, token: string) {
        event.preventDefault();
        isDeleted ? this.undeleteRound(token) : this.deleteRound(token)
    }

    private undeleteRound(token: string) {
        this.subscriptions.push(
            this.service.undeleteRound(token).subscribe({
                next: () => {
                    const round = this.rounds().find(round => round.token === token);
                    round!.isDeleted = false
                },
                error: (_: HttpErrorResponse) => {
                    this.alertService.showAlert("danger", "Error undeleting", null);
                }
            }))
    }

    private deleteRound(token: string) {
        this.subscriptions.push(
            this.service.deleteRound(token).subscribe({
                next: () => {
                    const round = this.rounds().find(round => round.token === token);
                    round!.isDeleted = true
                },
                error: (_: HttpErrorResponse) => {
                    this.alertService.showAlert("danger", "Error deleting", null);
                }
            }))
    }

    protected readonly Tab = Tab;
}

export enum Tab {
    Installs, Rounds, Properties
}
